import { render } from "./NavigationStepButtons.vue?vue&type=template&id=2a4ee17e"
import script from "./NavigationStepButtons.vue?vue&type=script&lang=js"
export * from "./NavigationStepButtons.vue?vue&type=script&lang=js"

import "./NavigationStepButtons.vue?vue&type=style&index=0&id=2a4ee17e&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__